import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Fallback from "components/Fallback";
import useFetchMapById from "services/hooks/useFetchMapById";
import useFetchMaps from "services/hooks/maps/useFetchMaps";

const RedirectMap = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const entityId = searchParams.get("entityId") || "";
  const mapId = searchParams.get("mapId") || "";

  const { isSuccess: isSuccessMap, isError: isErrorMap } = useFetchMapById(
    entityId,
    mapId
  );

  const {
    isSuccess: isSuccessMapsLast,
    data: mapsLast,
    refetch,
  } = useFetchMaps({
    entityId,
    pageSize: 2,
  });

  useEffect(() => {
    if (!mapId && !isSuccessMapsLast) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId, isSuccessMapsLast]);

  useEffect(() => {
    if (mapId && isErrorMap) {
      searchParams.delete("mapId");
      setSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapId, isErrorMap]);

  useEffect(() => {
    if (!mapId && isSuccessMapsLast) {
      const mapLast = mapsLast[0] || null;
      const mapBeforeLast = mapsLast[1] || null;

      if (mapLast && mapLast.status === "finished") {
        searchParams.append("mapId", mapLast.id);
        setSearchParams(searchParams);
      } else if (mapBeforeLast && mapBeforeLast.status === "finished") {
        searchParams.append("mapId", mapBeforeLast.id);
        setSearchParams(searchParams);
      } else if (mapLast) {
        searchParams.append("mapId", mapLast.id);
        setSearchParams(searchParams);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessMapsLast, mapId, mapsLast]);

  return mapId && (isSuccessMap || isSuccessMapsLast) ? children : <Fallback />;
};

export default RedirectMap;
